'use strict'

var Marionette = require('marionette')
var App = require('app')

/* Views */
var List = require('./list')

var PageDevices = function () {
  /* Routes ----------------------------------------------------------------- */
  var Router = App.PermissionAppRouter.extend({
    appRoutes: {
      'devices': 'list'
    }
  })

  /* API -------------------------------------------------------------------- */
  var API = {
    list: function () {
      var list = new List()
    }
  }

  /* Listeners -------------------------------------------------------------- */
  App.globalChannel.on('page-devices:list', function (options) {
    API.list()
  })

  new Router({ controller: API })
}

module.exports = PageDevices



// WEBPACK FOOTER //
// ./js/modules/page-devices/index.js